import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import { Routes } from '_pages/routes'
import { store } from '_legacy/store'

export const App = () => (
  <Provider store={store}>
    <HashRouter>
      <Routes />
    </HashRouter>
  </Provider>
)
